import { BigArrow } from './BigArrow';
import PropTypes from 'prop-types';
import React from 'react';
import { SmallArrow } from './SmallArrow';
import cn from 'classnames';

import styles from './styles.module.scss';

const ArrowSvg = ({ className, isSmall, direction }) => {
  const getArrowClassName = () => {
    switch (direction) {
      case 'left':
        return styles.left;
      case 'up':
        return styles.up;
      case 'down':
        return styles.down;
      case 'right':
      default:
        return styles.right;
    }
  };

  const arrowClassName = cn(className, getArrowClassName());

  return isSmall ? <SmallArrow className={arrowClassName} /> : <BigArrow className={arrowClassName} />;
};

export default ArrowSvg;

ArrowSvg.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(['left', 'right', 'up', 'down']),
  isSmall: PropTypes.bool,
};

ArrowSvg.defaultProps = {
  direction: 'right',
  isSmall: false,
};
